import React, {Component} from 'react';
import {Navigate} from "react-router-dom";
import {getSubjects} from "../services/SubjectService";
import {LearnSection} from "./LearnSection";
import {LearnBox} from "./LearnBox";
import {LearnPage} from "./LearnPage";
import {PointsProgress} from "./PointsProgress";
import {SubjectButton} from "./SubjectButton";

export class Problems extends Component {
    static displayName = Problems.name;

    constructor(props) {
        super(props);
        this.state = {subjects: [], loading: true};
    }

    static renderSubjects(subjects) {
        if (subjects.length === 1) {
            return <Navigate to={"/subject/" + subjects[0].key}/>;
        }

        return (
            <LearnSection>
                {subjects.map(subject =>
                    <LearnBox key={subject.key}>
                        <SubjectButton title={subject.displayName} url={"/subject/" + subject.key}></SubjectButton>
                        <PointsProgress subjectKey={subject.key}/>
                    </LearnBox>
                )}
            </LearnSection>
        );
    }

    componentDidMount() {
        this.fetchSubjects();
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Indlæser emner ...</em></p>
            : Problems.renderSubjects(this.state.subjects);

        return (
            <LearnPage>
                {contents}
            </LearnPage>
        );
    }

    fetchSubjects() {
        getSubjects().then(data => this.setState({subjects: data, loading: false}));
    }
}